import { toastStore } from 'shared/ui'
import { logger } from 'shared/lib'
import { UsersApi } from 'entities/Users'

export const assumeClient = async (id: number) => {
  try {
    const { data } = await UsersApi.assumeUser(id)
    const windowAssume = window.open(`${window.location.origin}/conversations/null`)

    if (windowAssume) {
      windowAssume.sessionStorage.setItem('assume_token', data.assume_token)
    }
  } catch (e) {
    if (e instanceof Error) {
      toastStore.add({
        title: e.message,
        type: 'error',
      })
    }
    logger.error(e)
  }
}
